export const UPDATE_BRAND_FUNCTIONS_STATE = 'UPDATE_BRAND_FUNCTIONS_STATE'
export const BRAND_FUNCTION_CREATED = 'BRAND_FUNCTION_CREATED'
